var map = {
	"./1-1-p2.svg": "9d0c",
	"./1-1-p3.svg": "2adf",
	"./1-1-p4.svg": "8e7e",
	"./1-1.svg": "f68d",
	"./1-2-p2.svg": "44e8",
	"./1-2-p3.svg": "d2bf",
	"./1-2-p4.svg": "40c1",
	"./1-2.svg": "09a4",
	"./1-3-p2.svg": "c978",
	"./1-3-p3.svg": "cdc9",
	"./1-3-p4.svg": "550b",
	"./1-3.svg": "c07f",
	"./1-4-p2.svg": "c981",
	"./1-4-p3.svg": "cdd2",
	"./1-4-p4.svg": "a1d9",
	"./1-4.svg": "3881",
	"./1-5-p2.svg": "1118",
	"./1-5-p3.svg": "39b0",
	"./1-5-p4.svg": "8318",
	"./1-5.svg": "2eea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b711";